import axios from '../../helpers/axios-setup';
import { TestCaseFormValues } from '../../components/pages/test-case/types';

export const createNewTC = (data: TestCaseFormValues) => axios.post('/test-cases', data);
